export enum EventTypeEnum {
  MESSAGE = 'message',
  NOTE = 'note',
  LOG = 'log',
  TIMESTAMP = 'timestamp',
  LINK_CLICKED = 'link_clicked',
}
